import styled from 'styled-components';
import { BreakPoint } from 'styles/style-variables/breakpoint';
import { EColors } from 'styles/style-variables/colors';
import { FontFamily } from 'styles/style-variables/font-family';

import { SText } from 'components/styled/SText';
import { Button } from 'components/ui/Button';

export const ElectricityArticle = styled.section`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;

  @media (max-width: ${BreakPoint.TabletTop}) {
    gap: 32px;
  }

  @media (max-width: ${BreakPoint.MobileTop}) {
    flex-direction: column;
    align-items: start;
    gap: 12px;
  }
`;

export const BalanceWrapper = styled.dl`
  display: flex;
  align-items: center;
  justify-content: space-between;
  order: 0;
  gap: 16px;

  @media (max-width: ${BreakPoint.TabletTop}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
`;

export const BalanceTitle = styled.dt`
  display: flex;
  gap: 8px;
  width: min-content;
  max-width: 145px;
  font-family: ${FontFamily.Montserrat};
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: ${EColors.Gray2};
  font-variant-numeric: lining-nums tabular-nums;

  @media (max-width: ${BreakPoint.TabletTop}) {
    min-width: max-content;
    white-space: nowrap;
  }
`;

export const ElectricityIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg {
    width: 28px;
    height: 28px;
    aspect-ratio: 1/1;
  }

  @media (max-width: ${BreakPoint.TabletTop}) {

    & > svg {
      width: 12px;
      height: 12px;
      aspect-ratio: 1/1;
    }
  }
`;

export const BalanceValue = styled.dd`
  display: flex;
  gap: 8px;
  min-width: max-content;
  font-family: ${FontFamily.Montserrat};
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  color: ${EColors.Gray1Text};
  font-variant-numeric: lining-nums tabular-nums;

  @media (max-width: ${BreakPoint.LaptopTop}) {
    font-size: 18px;
    line-height: 24px;
  }

  @media (max-width: ${BreakPoint.TabletTop}) {
    align-self: start;
    font-size: 16px;
    line-height: 20px;

    & > svg {
      width: 12px;
      height: 12px;
      aspect-ratio: 1/1;
    }
  }
`;

export const ReplenishButtonWrapper = styled.dl`
  display: flex;
  order: 1;

  @media (max-width: ${BreakPoint.TabletTop}) {
    justify-content: flex-end;
    order: 5;
    width: 100%;
  }
`;

export const ReplenishButton = styled(Button)`
  padding: 7px 16px;

  @media (max-width: ${BreakPoint.MobileTop}) {
    width: 100%;
  }
`;

export const Separator1 = styled.div`
  order: 1;
  width: 1px;
  height: calc(100% + 32px);
  background: ${EColors.Gray4};
  opacity: 0.3;

  @media (max-width: ${BreakPoint.TabletTop}) {
    display: none;
  }
`;

export const DailyPaymentWrapper = styled.dl`
  display: flex;
  flex-direction: column;
  order: 2;

  @media (max-width: ${BreakPoint.TabletTop}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
`;

export const PaymentTitle = styled(BalanceTitle)`
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: max-content;
  white-space: nowrap;
`;

export const PaymentValue = styled.dd`
  min-width: max-content;
  font-family: ${FontFamily.Montserrat};
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  color: ${EColors.Gray1Text};

  @media (min-width: ${BreakPoint.TabletLow}) and (max-width: ${BreakPoint.LaptopTop}) {
    font-size: 14px;
    line-height: 18px;
  }
`;

export const PerKwValue = styled(SText)`
  font-size: 12px;
  line-height: 16px;
  color: ${EColors.Gray2};
  font-variant-numeric: lining-nums tabular-nums;

  @media (max-width: ${BreakPoint.LaptopTop}) {
    font-size: 10px;
    line-height: 14px;
    letter-spacing: 0.2px;
  }
`;

export const Separator2 = styled(Separator1)`
  order: 2;
`;

export const SufficientForWrapper = styled.dl`
  display: flex;
  flex-direction: column;
  order: 4;

  @media (max-width: ${BreakPoint.TabletTop}) {
    display: none;
  }
`;

export const SufficientTitle = styled(PaymentTitle)`
  @media (max-width: ${BreakPoint.TabletTop}) {
    display: none;
  }
`;

export const Container = styled.div`
  display: flex;
  gap: 8px;
`;

export const SufficientValue = styled(PaymentValue)`
  @media (max-width: ${BreakPoint.TabletTop}) {
    padding: 4px;
    border-radius: 8px;
    background-color: #e5eaf1;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 14px;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    font-variant-numeric: lining-nums tabular-nums;
  }

  @media (max-width: ${BreakPoint.MobileTop}) {
    justify-self: start;
  }
`;

export const UntilDateValue = styled(SText)`
  font-size: 12px;
  line-height: 16px;
  color: ${EColors.Gray2};
  font-variant-numeric: lining-nums tabular-nums;

  @media (min-width: ${BreakPoint.LaptopLow}) and (max-width: ${BreakPoint.LaptopTop}) {
    font-size: 10px;
    line-height: 14px;
    letter-spacing: 0.2px;
  }

  @media (max-width: ${BreakPoint.TabletTop}) {
    display: none;
  }
`;

export const SufficientValueUsdDay = styled(SText)`
  align-self: center;
  grid-area: sufficient-value-usd;
  text-transform: lowercase;

  @media (min-width: ${BreakPoint.TabletTop}) {
    display: none;
  }

  @media (max-width: ${BreakPoint.TabletTop}) {
    font-size: 12px;
    line-height: 16px;
    font-variant-numeric: lining-nums tabular-nums;
  }

  @media (max-width: ${BreakPoint.MobileTop}) {
    justify-self: start;
  }
`;
